import _defineProperty from'@babel/runtime/helpers/defineProperty';import {useLocation}from'react-router-dom';import'url-search-params-polyfill';var QUERY_PARAMS = {
  UI_LOCALES: 'ui_locales',
  SIGN_OUT_MSG: 'sign_out',
  EMBEDDED: 'embedded',
  CONTEXT: 'context',
  RETURN_URL: 'returnUrl',
  GO_TO: 'goto'
};

// string types are supported implicitly; all params are strings unless otherwise stated
var TYPES = {
  BOOLEAN: 'boolean'
};
var TYPE_VALIDATORS = _defineProperty({}, TYPES.BOOLEAN, function (val) {
  if (val === 'true') {
    return true;
  }
  if (val === 'false') {
    return false;
  }
  return null;
});
var PARAM_VALIDATORS = _defineProperty({}, QUERY_PARAMS.EMBEDDED, TYPE_VALIDATORS[TYPES.BOOLEAN]);

// return querystring as key/value pairs
// e.g. ?foo=bar&hello=world => { ui: 'en_CA', embedded: false }
var useQuerystring = function useQuerystring() {
  var _useLocation = useLocation(),
    search = _useLocation.search;
  if (!search) {
    // no query string to use
    return {};
  }
  var searchParams = new URLSearchParams(search);
  return Object.values(QUERY_PARAMS).reduce(function (acc, param) {
    var value = searchParams.get(param);
    var verifiedValue = PARAM_VALIDATORS[param] ? PARAM_VALIDATORS[param](value) : value;
    if (verifiedValue !== null) {
      acc[param] = verifiedValue;
    }
    return acc;
  }, {});
};
var useQueryParams = useQuerystring;export{QUERY_PARAMS,useQueryParams as default};